import { DefaultComparator } from './comparators/default-comparator';
import {
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions
} from '../filter-types';
import {
  CalendarGridColumnLabel,
  CalendarGridColumnName
} from '../../../grid/types/column.types';
import { convertToStringArray } from '../filter-utils';
import { SeriesFilterHandler } from './base/series-filter-handler';

export class ERPFilterHandler extends SeriesFilterHandler {
  private comparator: IFilterComparator<any>;

  get name(): string {
    return CalendarGridColumnName.ERP;
  }

  get label(): string {
    return CalendarGridColumnLabel.ERP;
  }
  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.erp = params.filterOptions.erp;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.erp);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(options): IFilterComparator<any> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }
}
